import { InjectionToken } from "@angular/core";

export const SHOW_LOADING_FOR_GET = new InjectionToken<boolean>("Whether to show the loading spinner for GET requests");
